import React from "react";
import styles from "./Timeline.scss";
import classNames from "classnames";

export const Timeline = ({ children, openEnded }) => {
    let withIcons = false;
    React.Children.forEach(children, (child) => {
        if (child?.props?.icon) {
            withIcons = true;
        }
    });
    return (
        <div className={classNames(styles.timeline, { [styles.withIcons]: withIcons, [styles.openEnded]: openEnded })}>
            {children}
        </div>
    );
};
